import {
  DATE_FORMAT_FULL_WITH_HOURS_MINS,
  DATE_FORMAT_WITH_COMMA_HOUR_MINS,
  displayDate,
} from 'utils/date';

export const formatDateForName = (dateTime: string) =>
  displayDate(dateTime, DATE_FORMAT_FULL_WITH_HOURS_MINS);

export const formatDate = (dateTime: string) =>
  displayDate(dateTime, DATE_FORMAT_WITH_COMMA_HOUR_MINS);
